import { useTranslation } from 'next-i18next';
import { type CategoryDisplayText } from '@/views/build/features/category-display-text';
import { type CategorySelectorState, PlainSelection } from '@/views/build/features/category-select-view';
export const GradeSelection = ({
  categoryInfo,
  displayText
}: {
  categoryInfo: CategorySelectorState;
  displayText: CategoryDisplayText;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  return <PlainSelection value={categoryInfo.grade.selectedGradeNode} label={t('common:school.info.grade')} isActive={!!categoryInfo.grade.gradeNodes} isEmpty={categoryInfo.grade.gradeNodes?.length === 0} options={categoryInfo.grade.gradeNodes ?? []} error={categoryInfo.errors.gradeId} onChange={categoryInfo.updateCategoryInfo} onHover={value => {
    displayText.updateHoverPreview({
      field: 'gradeId',
      value: value.nodeId,
      label: value.label
    });
  }} onHoverLeave={() => {
    displayText.clearHoverPreview('gradeId');
  }} data-sentry-element="PlainSelection" data-sentry-component="GradeSelection" data-sentry-source-file="GradeSelection.tsx" />;
};